import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{class:_vm.getColourTheme},[_c('dui-snackbar',{attrs:{"color":_vm.snackColor,"message":_vm.snackMessage,"classSnack":_vm.snackClass,"styleSnack":_vm.snackStyle},model:{value:(_vm.snackOpen),callback:function ($$v) {_vm.snackOpen=$$v},expression:"snackOpen"}}),_vm._v(" "),_c('ErrorDialog'),_vm._v(" "),_c(VMain,[_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }